import http from 'hub-http/clients/apiClient';
import { FILE_MANAGER_WRITE_SCOPE } from '../Constants';
const BASE_URL = `vetting/public/v1/account-verification/state/scope`;
export const requestSuspensionStatus = () => {
  return http.get(`${BASE_URL}/${FILE_MANAGER_WRITE_SCOPE}`);
};